import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

const GetPlanningPageData = () =>
    request({
        url: ApiURL.Query.StudioQueryURLs.PlanningQueryURL.GetPlanningPageData,
        method: RequestType.GET,
    });

const GetPlannings = (params: any) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.PlanningQueryURL.GetPlannings,
        method: RequestType.GET,
        params,
    });

const GetPlanById = (params: any) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.PlanningQueryURL.GetPlanById + '/' + params.id,
        method: RequestType.GET,
        params,
    });

const GetPlanningShots = (params: any) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.PlanningQueryURL.GetPlanningShots,
        method: RequestType.GET,
        params,
    });

export const PlanningQuery = {
    GetPlanningPageData,
    GetPlannings,
    GetPlanById,
    GetPlanningShots,
};
